// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2LZN6","content":"RecentSearches_content__6Phzr"};